"use client"

import { ProfileMenuSubTrigger } from "@/components/profile-menu-sub-trigger"
import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
} from "@/components/ui/dropdown-menu"
import {
  useStepsEmbedNavMode,
  type StepsEmbedNavMode,
} from "@/hooks/use-steps-embed-nav-mode"

const OPTIONS: { id: StepsEmbedNavMode; label: string; description: string }[] = [
  {
    id: "tabs",
    label: "Top tabs",
    description: "Show the horizontal tab bar inside the demo product pane.",
  },
  {
    id: "sidebar",
    label: "Sidebar",
    description: "Hide top tabs. Show the left sidebar inside the demo product pane.",
  },
]

export function StepsEmbedNavModeMenu() {
  const [mode, setMode] = useStepsEmbedNavMode()
  const active = OPTIONS.find(option => option.id === mode)

  return (
    <DropdownMenuSub>
      <ProfileMenuSubTrigger
        iconClassName="fa-light fa-table-columns"
        label="Demo navigation"
        trailing={active?.label}
      />
      <DropdownMenuSubContent className="w-72">
        <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">
          Localhost demo pane
        </DropdownMenuLabel>
        <DropdownMenuRadioGroup
          value={mode}
          onValueChange={value => {
            const next = value as StepsEmbedNavMode
            if (next === mode) return
            setMode(next)
            window.location.reload()
          }}
        >
          {OPTIONS.map(option => (
            <DropdownMenuRadioItem
              key={option.id}
              value={option.id}
              className="items-start gap-2 py-2"
            >
              <span className="flex flex-col gap-0.5">
                <span className="font-medium">{option.label}</span>
                <span className="text-xs leading-snug text-muted-foreground">
                  {option.description}
                </span>
              </span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
